<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <table class="table">
          <table-row label="Image" :noBorder="true">
            <v-lazy-image
              v-if="branch.image"
              :src="branch.image"
              class="img-fluid maxHeight200"
            />
          </table-row>

          <table-row label="Branch">
            <p class="nl2br">{{ branch.name }}</p>
          </table-row>

          <table-row label="Code">
            <p class="nl2br">{{ branch.code }}</p>
          </table-row>

        
          <table-row icon="lni-database" :noBorder="true" />

          <table-row label="Id">
            {{ branch.id }}
          </table-row>

          <table-row label="Created">
            {{
              moment(new Date(branch.created_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
          <table-row label="Updated">
            {{
              moment(new Date(branch.updated_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import branchRepo from "@/api/repos/branchRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getBranch();
  },

  data() {
    return {
      loading: false,
      branch: {},
    };
  },

  methods: {
    async getBranch() {
      try {
        this.loading = true;
        let { data } = await branchRepo.get(this.id);
        this.branch = data.branch;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
